import React from "react";
import { Card, CardBody } from "reactstrap";
import {
  DRIVER,
  MY_BADGES,
  SERIAL_NUMBER,
} from "Constant";
import { Button } from "primereact/button";
import Swal from "sweetalert2";

import Breadcrumbs from "Components/Breadcrumbs";
import BadgesDataTable from "./BadgesDataTable";
import BadgeToDriver from "./BadgeToDriver";
import Loading from "Components/Loading/Loading";
import { getData } from "helper/getData";
import { useQuery } from "@tanstack/react-query";
import axiosClient from "Services/axiosClient";

const BadgesPage = () => {
  const breadCrumbsProps = [MY_BADGES];
  const list = "/front/badges?index=-1";
  
  const handleUpdateCounters = async () => {
    try {
      const result = await Swal.fire({
        title: 'Confirmation',
        text: "Voulez-vous mettre à jour tous les compteurs ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non'
      });

      if (result.isConfirmed) {
        await axiosClient.request({
          method: 'LINK',
          url: "/front/taximeters/drivers"
        });
        
        Swal.fire(
          'Succès!',
          'Les compteurs ont été mis à jour.',
          'success'
        );
      }
    } catch (error) {
      console.error('Error updating counters:', error);
      /*Swal.fire(
        'Erreur',
        'Une erreur est survenue lors de la mise à jour des compteurs.',
        'error'
      );*/
    }
  };

  const { 
    data: driversData, 
    isLoading: isLoadingDrivers, 
    isError: isErrorDrivers,
    error: driversError
  } = useQuery({
    queryKey: ['drivers'],
    queryFn: async () => {
      const response = await axiosClient.get("/front/driversChoices");
      return response.data.results.data; 
    }
  });

  const drivers = driversData || [];

  if (isLoadingDrivers) return <Loading />;
  if (isErrorDrivers) {
    console.error('Error fetching drivers:', driversError);
    return <div>Error loading drivers data</div>;
  }

  const COLUMNS = [
    {
      name: "#",
      field: "index",
      body: (_, { rowIndex }) => rowIndex + 1,
      style: { width: '4rem' }
    },
    {
      name: SERIAL_NUMBER,
      selector: "serial_number",
      field: "serial_number"
    },
    {
      name: DRIVER,
      field: "driver_name",
      body: (data) => {
        return <BadgeToDriver row={data} drivers={drivers} />;
      },
    },
  ];

  return (
    <Card>
      <CardBody>
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Breadcrumbs breadCrumbsProps={breadCrumbsProps} />
            <Button
              label="Mettre à jour tous les compteurs"
              icon="pi pi-refresh"
              severity="warning"
              onClick={handleUpdateCounters}
            />
          </div>
          <BadgesDataTable createBtn={false} newColumns={COLUMNS} link={list} />
        </div>
      </CardBody>
    </Card>
  );
};

export default BadgesPage;
